import Purchase from '@/api/purchase'

export default {
  fetchPerPage: ({ commit, getters, rootState }, {
    page = 1,
    userId = null,
    adminId = null,
    offerId = null,
    serviceType = null,
    resultCode = null,
    dateFilter = null,
    from = null,
    to = null,
    scope = 'all'
  }) => {
    commit('changeLoading', { isLoading: true })
    return Purchase.fetchAll({ page, userId, adminId, offerId, serviceType, resultCode, scope, dateFilter, from, to })
      .then(({ data, pagination }) => {
        commit('collectionForPageFetched', {
          collectionForPage: data,
          pagination,
          scope: {
            page,
            userId,
            adminId,
            offerId,
            serviceType,
            resultCode,
            from,
            to,
            dateFilter,
            scope
          }
        })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => {
        commit('purchaseError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  fetch: ({ commit }, { id }) => {
    commit('changeLoading', { isLoading: true })
    return Purchase.fetch({ id })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => {
        commit('purchaseError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  refund: ({ commit }, { id, reason }) => {
    commit('changeLoading', { isLoading: true })
    return Purchase.refund({ id, reason })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => {
        commit('purchaseError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  accept: ({ commit }, { id }) => {
    commit('changeLoading', { isLoading: true })
    return Purchase.accept({ id })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => {
        commit('purchaseError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  finish: ({ commit }, { id, serviceType, data }) => {
    commit('changeLoading', { isLoading: true })
    return Purchase.finish({ id, data, serviceType })
      .then(({ data }) => {
        commit('replaceItem', { item: data })
        commit('changeLoading', { isLoading: false })
        return data
      })
      .catch(error => {
        commit('purchaseError', { error: error.response ? error.response.data.error : error.message })
        commit('changeLoading', { isLoading: false })
        throw error
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/purchases/actions.js